import styled from "@emotion/styled";

export const StyledStatusContainer = styled.div<{ $isClickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[0.5]};
  cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
`;

export const StyledStatusContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[0.5]};
`;

export const StyledCalendarInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[0.5]};
`;
